import { ChangeEvent, useEffect, useState } from 'react';

import './rounding.scss';

import { updateRounding } from '~modules/rounding/api';
import { RoundingErrorDto } from '~modules/rounding/dto';
import { Preloader, toastError, toastSuccess } from '~shared/ui';
import { SaveBtn } from '~shared/ui/button/save-btn';
import { InputItem } from '~shared/ui/input-item/input-item';

import { RoundingGraph } from './rounding-graph';
import { useRounding } from './use-rounding';

export function RoundingPage() {
	const { data, pending } = useRounding();
	const [rounding, setRounding] = useState<RoundingErrorDto>();

	useEffect(() => {
		if (data) setRounding(data);
	}, [data]);

	const handleSave = async () => {
		if (!rounding) return;
		try {
			await updateRounding(rounding);
			toastSuccess('Настройки погрешностей обновлены');
		} catch (err) {
			if (err instanceof Error) {
				toastError(err.message);
			} else console.error(err);
		}
	};

	return (
		<div className="rounding-page page">
			{pending ? (
				<Preloader style={{ margin: '40px 0' }} />
			) : (
				<div className="page-container">
					<h2 className="page-title">Таблица погрешностей</h2>
					<RoundingGraph />
					<table className="table-for-tabel">
						<thead style={{ border: 'none' }}>
							<tr>
								<th style={{ textAlign: 'center' }}>Начало рабочего дня</th>
								<th></th>
								<th></th>
								<th></th>
								<th style={{ textAlign: 'center' }}>Конец рабочего дня</th>
							</tr>
						</thead>
						<tbody>
							<tr style={{ height: '100px' }}>
								<RoundingPage.Td
									value={rounding?.early_arrival_deviation ?? 0}
									onChange={e => {
										setRounding(state =>
											state
												? {
														...state,
														early_arrival_deviation: parseInt(e.target.value) || 0,
													}
												: state,
										);
									}}
									title="Отклонение на приход раньше"
								/>
								<RoundingPage.Td
									title="Округление на приход"
									onChange={e => {
										setRounding(state =>
											state
												? {
														...state,
														early_arrival_rounding: parseInt(e.target.value) || 0,
													}
												: state,
										);
									}}
									value={rounding?.early_arrival_rounding ?? 0}
								/>

								<td></td>

								<RoundingPage.Td
									title="Округление на уход"
									onChange={e => {
										setRounding(state =>
											state
												? {
														...state,
														late_departure_rounding: parseInt(e.target.value) || 0,
													}
												: state,
										);
									}}
									value={rounding?.late_departure_rounding ?? 0}
								/>
								<RoundingPage.Td
									title="Отклонение на уход позже"
									onChange={e => {
										setRounding(state =>
											state
												? {
														...state,
														late_departure_deviation: parseInt(e.target.value) || 0,
													}
												: state,
										);
									}}
									value={rounding?.late_departure_deviation ?? 0}
								/>
							</tr>
						</tbody>
					</table>
					<SaveBtn style={{ margin: '20px auto 0' }} handleSave={handleSave} disabled={!rounding} />
				</div>
			)}
		</div>
	);
}

const Td = ({
	onChange,
	value,
	title,
}: {
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	value: number;
	title: string;
}) => {
	return (
		<td style={{ width: '250px' }}>
			<div style={{ marginBottom: '20px', whiteSpace: 'nowrap', fontSize: '14px' }}>{title}</div>
			<InputItem type="number" min="0" onChange={onChange} value={value} />
		</td>
	);
};

RoundingPage.Td = Td;
